export class ContactUsMailMessage {      
    facility: string;
    areaOfConcern: string;
    userName: string;
    emailAddress:string;
    phoneNumber:string;
    subject?: string;
    comments?: string; 
  }
  